import { ReactComponent as BackIcon } from 'assets/images/icons/arrows/arrow-left.svg';

const BackButton = () => {
  return (
    <button className="w-8 h-8 bg-transparent border-none cursor-pointer">
      <BackIcon />
    </button>
  );
};

export default BackButton;
